import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 保存空运航线
export function saveAirRoute(data) {
  return request({
    url: URL.mdm.basicData.saveAirRoute,
    method: 'post',
    data
  })
}

// 删除空运航线
export function deleteAirRoute(params) {
  return request({
    url: URL.mdm.basicData.deleteAirRoute,
    method: 'delete',
    params
  })
}
